import {Capacitor} from '@capacitor/core'
import { Navigate } from 'react-router';
import HomePage from '../components/HomePage';
const RootRedirector = () => {

    const isMobile = Capacitor.getPlatform() === 'android';

    if(isMobile){
        return <Navigate to="/login"/>
    }

    return <HomePage/>
}

export default RootRedirector;